<template>
  <v-list
    class="elevation-1"
    three-line
  >
    <slot
      name="row"
      v-bind="{ items: computedItems }"
    />

    <v-btn
      block
      text
      color="primary"
      @click="loadMore"
    >
      load more
    </v-btn>
  </v-list>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    itemsGetter: {
      type: String,
      default: ''
    },
    itemsPaginator: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([  ]),
    computedItems() {
      return this.$store.getters[ this.itemsGetter ] || []
      // return this.itemsGetter ? this[this.itemsGetter]() : []
    },
  },
  created() {
    this.$store.dispatch(this.itemsPaginator)
  },
  methods: {
    ...mapActions([]),
    loadMore() {

      this.$store.dispatch(this.itemsPaginator)
    }
  },
}
</script>
